/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Tracknew2Inputs */

const en_coinvestments_nrl_tracknew2 = /** @type {(inputs: Coinvestments_Nrl_Tracknew2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track new NRL`)
};

/**
* | output |
* | --- |
* | "Track new NRL" |
*
* @param {Coinvestments_Nrl_Tracknew2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_tracknew2 = /** @type {((inputs?: Coinvestments_Nrl_Tracknew2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Tracknew2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_tracknew2(inputs)
});
export { coinvestments_nrl_tracknew2 as "coInvestments_nrl_trackNew" }